/**
 * Real-time WebSocket Hooks - Barrel Export
 * Domain-specific hooks for streaming market data, orders, risk, arbitrage, and AI signals
 */

// Client dashboard secure ticket streams
export { useClientRealtime } from './useClientRealtime';
export type {
  ClientRealtimeStatus,
  UseClientRealtimeConfig,
  UseClientRealtimeReturn,
} from './useClientRealtime';

// Order execution streaming
export { useRealtimeOrders } from './useRealtimeOrders';
export type {
  RealtimeOrder,
  RealtimeFill,
  RealtimeExecution,
  OrderUpdateEvent,
  UseRealtimeOrdersConfig,
} from './useRealtimeOrders';

// Risk alert streaming
export { useRealtimeRiskAlerts } from './useRealtimeRiskAlerts';
export type {
  RealtimeRiskAlert,
  RealtimeRiskMetric,
  RealtimeViolation,
  UseRealtimeRiskAlertsConfig,
} from './useRealtimeRiskAlerts';

// System notification streaming
export { useRealtimeNotifications } from './useRealtimeNotifications';
export type {
  RealtimeNotification,
  SystemStatus,
  NotificationType,
  NotificationPriority,
  UseRealtimeNotificationsConfig,
} from './useRealtimeNotifications';

// Arbitrage opportunity streaming
export { useRealtimeArbitrage } from './useRealtimeArbitrage';
export type {
  RealtimeArbitrageOpportunity,
  RealtimeArbitrageExecution,
  ExchangeLatency,
  UseRealtimeArbitrageConfig,
} from './useRealtimeArbitrage';

// AI trading signal streaming
export { useRealtimeAITrading } from './useRealtimeAITrading';
export type {
  RealtimeAISignal,
  RealtimeAgentStatus,
  RealtimeAIPerformance,
  UseRealtimeAITradingConfig,
} from './useRealtimeAITrading';
